import React from "react";
import PropTypes from "prop-types";
import StylePropType from "react-style-proptype";
import Radium from "radium";
import enhanceWithClickOutside from "react-click-outside";
import PlusCircleIcon from "react-icons/lib/fa/plus-circle";
import TrashOIcon from "react-icons/lib/fa/trash-o";
import EditorPanel from "../EditorPanel";
import SortableList from "../SortableList";
import Styles from "./styles";
import JumperButton from "../UIKit/Button";
import AccessoryToolbar from "../AccessoryToolbar";
import AddScenePanel from "../AddScenePanel";

class ScenesPanel extends React.Component {
  constructor() {
    super();

    this.state = {
      isPanelOpen: false
    };

    this.renderLeftAccessory = this.renderLeftAccessory.bind(this);
    this.renderFooter = this.renderFooter.bind(this);
    this.renderOverlayPanel = this.renderOverlayPanel.bind(this);
    this.onPlusClick = this.onPlusClick.bind(this);
    this.onActionPanelClose = this.onActionPanelClose.bind(this);
    this.onValidSubmit = this.onValidSubmit.bind(this);
  }

  componentWillReceiveProps(newProps) {}

  onActionPanelClose() {
    this.createScenePanel.reset();
    this.setState({ isPanelOpen: false });
  }

  onValidSubmit(data) {
    this.props.onCreate(data);
    this.setState({ isPanelOpen: false });
  }

  onPlusClick() {
    if (!this.state.isPanelOpen) {
      this.setState({ isPanelOpen: true });
    } else {
      this.createScenePanel.submit();
    }
  }

  handleClickOutside() {
    this.createScenePanel.reset();
    if (this.state.isPanelOpen) {
      this.setState({ isPanelOpen: false });
    }
  }

  renderLeftAccessory() {
    return (
      <JumperButton
        onClick={this.onPlusClick}
        size="sm"
        style={[Styles.accessoryButton]}
        buttonStyle={this.state.isPanelOpen ? Styles.accessoryButtonActive : {}}
      >
        <PlusCircleIcon size={17} />
      </JumperButton>
    );
  }

  renderRightAccessory() {
    if (!this.state.isPanelOpen && this.props.selected) {
      return (
        <JumperButton
          onClick={() => {
            this.props.onDelete(this.props.selected);
          }}
          size="sm"
          style={[Styles.accessoryButton]}
          buttonStyle={
            this.state.isPanelOpen ? Styles.accessoryButtonActive : {}
          }
        >
          <TrashOIcon size={17} />
        </JumperButton>
      );
    }
    return null;
  }

  renderFooter() {
    return (
      <AccessoryToolbar
        active={this.state.isPanelOpen}
        leftAccessory={this.renderLeftAccessory()}
        rightAccessory={this.renderRightAccessory()}
      />
    );
  }

  renderOverlayPanel() {
    return (
      <AddScenePanel
        ref={component => {
          this.createScenePanel = component;
        }}
        onValidSubmit={this.onValidSubmit}
        isOpen={this.state.isPanelOpen}
        onActionPanelClose={this.onActionPanelClose}
        onWidgetSelect={this.onWidgetSelect}
      />
    );
  }

  render() {
    const { title, titleEditable, hasFocus } = this.props;

    return (
      <EditorPanel
        style={this.props.style}
        title={title}
        titleEditable={titleEditable}
        hasFocus={hasFocus}
        renderFooter={this.renderFooter}
        renderOverlayPanel={this.renderOverlayPanel}
        onClick={this.props.onClick}
      >
        <SortableList
          selected={this.props.selected}
          items={this.props.items}
          onItemClick={this.props.onItemClick}
          disabledItems={this.props.disabledItems}
        />
      </EditorPanel>
    );
  }
}

ScenesPanel.propTypes = {
  style: StylePropType,
  title: PropTypes.string,
  titleEditable: PropTypes.bool,
  onCreate: PropTypes.func,
  onDelete: PropTypes.func,
  onItemClick: PropTypes.func,
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  items: PropTypes.array,
  onClick: PropTypes.func,
  hasFocus: PropTypes.bool
};

ScenesPanel.defaultProps = {
  style: {},
  title: "",
  titleEditable: false,
  onCreate: () => {},
  onDelete: () => {},
  onItemClick: () => {},
  selected: null,
  items: [],
  onClick: () => {},
  hasFocus: false
};

export default Radium(enhanceWithClickOutside(ScenesPanel));



// WEBPACK FOOTER //
// ./src/components/ScenesPanel/index.js